<template>
  <Modal variant="site-keyword-analysis" @close="close">
    <template slot="title">
      絞り込み条件の設定
    </template>
    <template slot="content">
      <p v-if="!hasFilters">保存された絞り込み条件はありません。</p>
      <div v-else class="l-mb-6">
        <h2 class="hTitle">保存されている絞り込み条件の一覧</h2>
        <table class="c-table edit">
          <thead>
            <tr>
              <td width="195">登録日</td>
              <td>絞り込み条件名</td>
              <td width="69">削除</td>
            </tr>
          </thead>
          <tbody>
            <ModalDeleteFilterItem
              v-for="item in storedFilters"
              :key="item.id"
              :item="item"
              @delete="deleteItem"
            />
          </tbody>
        </table>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal';
import ModalDeleteFilterItem from '@/components/siteKeywordAnalysis/ModalDeleteFilterItem';

export default {
  props: {
    storedFilters: {
      type: Array,
      required: true
    }
  },
  components: {
    Modal,
    ModalDeleteFilterItem
  },

  computed: {
    hasFilters() {
      return this.storedFilters.length;
    }
  },

  methods: {
    close() {
      this.$emit('close');
    },
    setStatus(status) {
      this.$store.dispatch('page/setStatus', {
        page: 'siteKeywordAnalysis',
        status: status
      });
    },
    deleteItem(id) {
      this.$emit('deleteItem', id);
    }
  }
};
</script>
